const modes = {
  preProduction: 0,
  production: 1,
  postProduction: 2
};
export default modes;
